import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "failed-oval",
  "use": "failed-oval-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"failed-oval\">\n<circle cx=\"9\" cy=\"9\" r=\"9\" fill=\"#DB4D41\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.6004 6.06113L11.9392 5.3999L9.00039 8.33868L6.06162 5.3999L5.40039 6.06113L8.33917 8.9999L5.40039 11.9387L6.06162 12.5999L9.00039 9.66113L11.9392 12.5999L12.6004 11.9387L9.66161 8.9999L12.6004 6.06113Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol